import { Component, Input, OnInit } from '@angular/core';
import { HorarioDTO, SemanaDTO } from 'app/main/apps/shared/interfaces/horarios.interface';

@Component({
  selector: 'app-horarios',
  templateUrl: './horarios.component.html',
  styleUrls: ['./horarios.component.scss']
})
export class HorariosComponent implements OnInit {

  @Input() horarios:SemanaDTO;

  

  constructor() { }

  ngOnInit(): void {
  }

}
